import ActivityTypeMapper from 'utils/ActivityTypeMapper';
import { ColorLimeDark1 } from 'ui-connect/styles/default-theme';

/**
 * Static Utility class used to map activity types to a corresponding css class.
 */
var FileNames = {
    cycling: 'map_marker_activity_cycling_pin.svg',
    hiking: 'map_marker_activity_hiking_pin.svg',
    other: 'map_marker_activity_other_pin.svg',
    running: 'map_marker_activity_running_pin.svg',
    swimming: 'map_marker_activity_swimming_pin.svg',
    transition: 'map_marker_activity_transition_pin.svg',
    transition_v2: 'map_marker_activity_transition_pin.svg',
    uncategorized: 'map_marker_activity_uncategorized_pin.svg',
    walking: 'map_marker_activity_walking_pin.svg',
    fitness_equipment: 'map_marker_activity_fitness_equipment_pin.svg',
    motorcycling: 'map_marker_activity_other_pin.svg',
    diving: 'map_marker_activity_diving.svg',
    single_gas_diving: 'map_marker_activity_singlegas.svg',
    multi_gas_diving: 'map_marker_activity_multigas.svg',
    gauge_diving: 'map_marker_activity_gauge.svg',
    apnea_diving: 'map_marker_activity_apnea.svg',
    apnea_hunting: 'map_marker_activity_apneahunt.svg',
    ccr_diving: 'map_marker_activity_ccr.svg',
    para_sports: 'map_marker_activity_para_sports_pin.svg',
    racket_sports: 'map_marker_activity_racket_sports_pin.svg',
    team_sports: 'map_marker_activity_team_sports_pin.svg',
    water_sports: 'map_marker_activity_water_sports_pin.svg',
    winter_sports: 'map_marker_activity_winter_sports_pin.svg',
    safety: 'map_marker_safety.svg'
};

var Colors = {
    cycling: '#DA3B61',
    hiking: '#C8661F',
    other: '#5A30D7',
    winter_sports: '#15AABF',
    water_sports: '#EA670E',
    running: '#0093C7',
    swimming: '#AE1297',
    transition: '#A7A7A7',
    transition_v2: '#A7A7A7',
    swimToBikeTransition_v2: '#A7A7A7',
    bikeToRunTransition_v2: '#A7A7A7',
    runToBikeTransition_v2: '#A7A7A7',
    uncategorized: '#A7A7A7',
    walking: '#439727',
    fitness_equipment: '#A10023',
    motorcycling: '#A7A7A7',
    diving: '#439727',
    single_gas_diving: '#439727',
    multi_gas_diving: '#439727',
    gauge_diving: '#439727',
    apnea_diving: '#439727',
    apnea_hunting: '#439727',
    ccr_diving: '#439727',
    [ActivityTypeMapper.TeamSports]: ColorLimeDark1,
    [ActivityTypeMapper.RacketSports]: ColorLimeDark1,
    safety: '#FF0035'
};

var ActivityTypeStyleMapper = {
    /**
     * Function that maps an activity type key to its corresponding file name
     * @param parentActivityType
     */
    mapStartPin: function(parentActivityType) {
        var fileName = FileNames[parentActivityType];

        if (!fileName) {
            fileName = FileNames.other;
        }

        return fileName;
    },

    /**
     * Function that maps an activity type key to its corresponding polyline color.
     * @param parentActivityType
     */
    mapPolylineColor: function(parentActivityType) {
        var color = Colors[parentActivityType];

        if (!color) {
            color = Colors.other;
        }

        return color;
    }
};

export default ActivityTypeStyleMapper;
